type QueuedRequest = {
  resolve: (token: string) => void;
  reject: (error: unknown) => void;
};

export const refreshLock = {
  isRefreshing: false,
  failedQueue: [] as QueuedRequest[],
};

export const resetTokenRefreshLock = (): void => {
  refreshLock.isRefreshing = false;
  refreshLock.failedQueue = [];
};
